import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=2824f672&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=ts"
export * from "./Documentation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824f672",
  null
  
)

export default component.exports